<template>
	<div class="category">
		<el-form :inline="true" class="demo-form-inline">
			<el-form-item label="时间">
				<el-date-picker style="width: 200px" v-model="formData.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="开始时间">
				</el-date-picker>
				-
				<el-date-picker style="width: 200px" v-model="formData.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="结束时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small" @click="getData()">查询</el-button>
				<el-button type="primary" size="small" @click="getData2()">查询明细</el-button>
			</el-form-item>
		</el-form>

		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column prop="box_id" label="箱子ID"></el-table-column>
				<el-table-column prop="return_rate" label="返奖率"></el-table-column>
				<el-table-column prop="total_draw_get_price" label="抽奖总额"></el-table-column>
				<el-table-column prop="total_draw_out_price" label="奖品总额"></el-table-column>
				<el-table-column prop="total_count" label="总抽奖次数"></el-table-column>
				<!-- <el-table-column label="操作" width="200px">
					<template slot-scope="{row}">
						<el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
						<el-button type="danger" @click="handleDelete(row.id)">删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>
		</div>
		<el-dialog :visible.sync="visibleEdit" :title="isEdit ? '编辑' : '添加'" width="400px">
			<el-form label-width="80px">
				<el-form-item prop="name" label="名称">
					<el-input v-model="editForm.name"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visibleEdit = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
			</span>
		</el-dialog>
		<el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0" :current-page="page"
			@current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import { getData, postData, patchData, delData } from '../../http'
	export default {
		data() {
			return {
				editForm: {
					name: ''
				},
				page: 1,
				editId: undefined,
				loading: false,
				visibleEdit: false,
				buttonLoading: false,
				isEdit: false,
				dataList: undefined, //数据列表
				dataMeta: undefined, //底部分页数据
				formData: {
					start_time: '',
					end_time: '',
				}
			}
		},
		computed: {},
		methods: {
			getData() {
				//获取数据列表
				this.loading = true
				this.dataList = [];
				let params = this.formData;
				getData(`box_calculation_query`, params).then(res => {
					this.dataList = res.data
					this.dataMeta = res
				}).finally(() => {
					this.loading = false
				})
			},
			getData2() {
				//获取数据列表
				this.loading = true
				this.dataList = [];
				let params = this.formData;
				getData(`box_calculation_query2`, params).then(res => {
					this.dataList = res.data
					this.dataMeta = res
				}).finally(() => {
					this.loading = false
				})
			},
			handleAdd() {
				this.isEdit = false
				this.editForm.name = ''
				this.visibleEdit = true
			},
			handleEdit(row) {
				this.isEdit = true
				this.editForm.name = row.name
				this.editId = row.id
				this.visibleEdit = true
			},
			handlePageChange(page) {
				this.page = page
				this.getData()
			},
			handleDelete(id) {
				this.$confirm('确定要删除吗？', {
					type: 'warning'
				}).then(res => {
					delData(`category/${id}`).then(res => {
						this.$message.success('删除成功')
						this.getData()
					})
				})
			},
			submit() {
				if (!this.editForm.name) {
					this.$message.error('请输入名称')
					return
				}
				this.buttonLoading = true
				if (this.isEdit && this.editId) {
					patchData(`category/${this.editId}`, {
							name: this.editForm.name
						})
						.then(res => {
							this.$message.success('编辑成功')
							this.visibleEdit = false
							this.getData()
							this.getCategories()
						})
						.finally(() => {
							this.buttonLoading = false
						})
				} else {
					postData('category', {
							name: this.editForm.name
						})
						.then(res => {
							this.$message.success('添加成功')
							this.visibleEdit = false
							this.getData()
							this.getCategories()
						})
						.finally(() => {
							this.buttonLoading = false
						})
				}
			}
		},
		created() {
			// this.getData()
		}
	}
</script>

<style>
</style>